import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { AdvisorService } from './advisor.service';
import { AdvisorListComponent } from './advisor-list.component';

@Component({
    selector: 'app-advisor-dialog-delete',
    templateUrl: './advisor-dialog-delete.component.html',
    styleUrls: ['./advisor-dialog-delete.component.css'],
    standalone: false
})
export class AdvisorDialogDeleteComponent {
  uid: number = this.data.uid;
  type: string = this.data.type;
  error_msg: string;
  error: boolean = false;

  constructor(
    public advisorService: AdvisorService,
    public dialogRef: MatDialogRef<AdvisorListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  delete() {
    this.advisorService.deleteData(this.uid);
    this.error = true;
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
